<template>
  <div class="dashed-lines">
    <contact-form />
    <div style="height: 86px"></div>
    <a class="anchor" id="pagetop"></a>
    <div class="background_image_hands">
      <div>
        <br />
        <br />
        <!--         <div
          class="text-white text-center font-weight-bold pt-5"
          style="font-size: 64px;"
        >
          Enlighten your world
        </div>

        <div
          class="text-white text-center font-alt mt-4"
          style="font-size: 36px; "
        >
          <div v-html="$t('seven_weeks')" />
        </div> -->

        <div
          class="text-white text-center font-weight-bold pt-4"
          style="font-size: 6rem"
        >
          Enlighten your world
        </div>

        <div
          class="text-white text-center font-alt mt-3"
          style="font-size: 3rem"
        >
          <div v-html="$t('seven_weeks')" />
        </div>

        <!--         <b-container fluid>
          <b-row class="justify-content-center mt-3">
            <b-btn
              v-b-modal.modal_contact_form
              variant="white"
              class="h3 mx-3 px-3 text-primary font-weight-bold font-alt"
              pill
              style="font-size: 16px; width: 190px"
            >
              {{ $t('free_demo') }}
            </b-btn>
            <b-btn
              v-b-modal.modal_contact_form
              variant="outline-white font-weight-bold font-alt"
              class="h3 mx-3 px-3"
              pill
              style="font-size: 16px; width: 190px"
            >
              {{ $t('contact_us') }}
            </b-btn>
          </b-row>
        </b-container> -->

        <b-container fluid>
          <b-row class="justify-content-center mt-3">
            <b-btn
              v-b-modal.modal_contact_form
              variant="white"
              class="h3 mx-3 px-3 text-primary font-weight-bold font-alt"
              pill
            >
              {{ $t('free_demo') }}
            </b-btn>
            <b-btn
              v-b-modal.modal_contact_form
              variant="outline-white font-weight-bold font-alt"
              class="h3 mx-3 px-3"
              pill
            >
              {{ $t('contact_us') }}
            </b-btn>
          </b-row>
        </b-container>

        <br />
      </div>
      <b-container fluid>
        <b-row class="justify-content-center no-gutters">
          <b-col cols="0" lg="3" xl="4" />
          <b-col cols="12" lg="6" xl="4" @click="start_video">
            <img
              src="@/assets/video_thumbnail.png"
              class="clickable_thumbnail"
            />
          </b-col>
          <b-col cols="0" lg="3" xl="4" />
        </b-row>
      </b-container>
    </div>

    <b-modal
      ref="videomodal"
      centered
      size="xl"
      hide-header
      hide-footer
      body-class="bg-black"
      @shown="on_videomodal_shown"
      @hidden="on_videomodal_hidden"
    >
      <div>
        <b-embed
          type="iframe"
          ref="cosmovideo"
          aspect="16by9"
          :src="video_src"
          allowfullscreen
        ></b-embed>
      </div>
    </b-modal>

    <br />
    <br />

    <b-container fluid>
      <a class="anchor" id="change"></a>
      <b-row class="my-5">
        <br />
        <br />
        <b-col>
          <h1 class="font-weight-bold text-center my-5">
            {{ $t('now_everywhere_everyone') }}
          </h1>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid>
      <b-row class="my-5">
        <b-col class="d-flex flex-column align-items-center" cols="12" lg="4">
          <div
            class="d-flex flex-column align-items-center unrollable_zone"
            @click="now_text_shown = !now_text_shown"
          >
            <!--             <lottie-player
              id="lottie_now_icon"
              ref="lottie_now_icon"
              loop
              hover
              mode="normal"
              src="https://assets9.lottiefiles.com/packages/lf20_2p2bls5d.json"
              style="width: 150px"
            /> -->
            <lottie-player
              id="lottie_now_icon"
              ref="lottie_now_icon"
              loop
              hover
              mode="normal"
              style="width: 200px"
            />
            <h2 class="text-primary font-alt font-weight-bold mt-0 mb-3">
              {{ $t('now') }}
            </h2>
            <!--             <div>
              <i
                class="text-primary fas fa-angle-down animate__animated animate__shakeY animate__infinite"
                style="font-size: 200%;"
              />
            </div> -->
            <!--             <div>
              <i
                class="text-primary fas fa-angle-down animate__animated animate__shakeY animate__infinite"
                style="font-size: 200%;"
              />
            </div> -->
            <lottie-player
              id="animated_arrow_1"
              ref="animated_arrow_1"
              autoplay
              loop
              mode="normal"
              style="width: 40px"
            />
          </div>

          <div
            class="mt-4"
            align="center"
            :class="now_text_class"
            :style="{ visibility: now_text_shown ? 'visible' : 'hidden' }"
            style="width: 100%; height: 100%"
          >
            <div
              class="d-block bg-white"
              style="width: 20px; height: 20px; transform: rotate(45deg)"
            />

            <b-card
              class="text-justify font-alt border-0"
              style="
                width: 75%;
                height: 100%;
                border-radius: 25px;
                margin-top: -10px;
              "
            >
              {{ $t('now_text') }}
            </b-card>
          </div>
          <!--           <lottie-player
            v-show="simple_text_shown"
            id="lottie_simple_text"
            ref="lottie_simple_text"
            autoplay
            mode="normal"
            style="width: 75%;"
          /> -->
        </b-col>
        <b-col class="d-flex flex-column align-items-center" cols="12" lg="4">
          <div
            class="d-flex flex-column align-items-center unrollable_zone"
            @click="everywhere_text_shown = !everywhere_text_shown"
          >
            <lottie-player
              id="lottie_everywhere_icon"
              ref="lottie_everywhere_icon"
              loop
              hover
              mode="normal"
              style="width: 200px"
            />
            <h2 class="text-primary font-alt font-weight-bold mb-3">
              {{ $t('everywhere') }}
            </h2>
            <!--             <div>
              <i
                class="text-primary fas fa-angle-down animate__animated animate__shakeY animate__infinite"
                style="font-size: 200%;"
              />
            </div> -->

            <lottie-player
              id="animated_arrow_2"
              ref="animated_arrow_2"
              autoplay
              loop
              mode="normal"
              style="width: 40px"
            />
          </div>
          <div
            class="mt-4"
            align="center"
            :class="everywhere_text_class"
            :style="{
              visibility: everywhere_text_shown ? 'visible' : 'hidden',
            }"
            style="width: 100%; height: 100%"
          >
            <div
              class="d-block bg-white"
              style="width: 20px; height: 20px; transform: rotate(45deg)"
            />

            <b-card
              class="text-justify font-alt border-0"
              style="
                width: 75%;
                height: 100%;
                border-radius: 25px;
                margin-top: -10px;
              "
            >
              {{ $t('everywhere_text') }}
            </b-card>
          </div>
          <!--           <lottie-player
            v-show="intelligent_text_shown"
            id="lottie_intelligent_text"
            ref="lottie_intelligent_text"
            autoplay
            mode="normal"
            style="width: 75%;"
          /> -->
        </b-col>
        <b-col class="d-flex flex-column align-items-center" cols="12" lg="4">
          <div
            class="d-flex flex-column align-items-center unrollable_zone"
            @click="everyone_text_shown = !everyone_text_shown"
          >
            <lottie-player
              id="lottie_everyone_icon"
              ref="lottie_everyone_icon"
              loop
              hover
              mode="normal"
              style="width: 200px"
            />
            <h2 class="text-primary font-alt font-weight-bold mb-3">
              {{ $t('for_everyone') }}
            </h2>
            <!--             <div>
              <i
                class="text-primary fas fa-angle-down animate__animated animate__shakeY animate__infinite"
                style="font-size: 200%;"
              />
            </div> -->

            <lottie-player
              id="animated_arrow_3"
              ref="animated_arrow_3"
              autoplay
              loop
              mode="normal"
              style="width: 40px"
            />
          </div>
          <div
            class="mt-4"
            align="center"
            :class="everyone_text_class"
            :style="{
              visibility: everyone_text_shown ? 'visible' : 'hidden',
            }"
            style="width: 100%; height: 100%"
          >
            <div
              class="d-block bg-white"
              style="width: 20px; height: 20px; transform: rotate(45deg)"
            />

            <b-card
              class="text-justify font-alt border-0"
              style="
                width: 75%;
                height: 100%;
                border-radius: 25px;
                margin-top: -10px;
              "
            >
              {{ $t('everyone_text') }}
            </b-card>
          </div>

          <!--           <lottie-player
            v-show="reliable_text_shown"
            id="lottie_reliable_text"
            ref="lottie_reliable_text"
            autoplay
            mode="normal"
            style="width: 75%;"
          /> -->
        </b-col>
      </b-row>
    </b-container>

    <br />
    <br />

    <img src="@/assets/first_wave_top.svg" style="width: 100%" />

    <div class="bg-white">
      <br />
      <br />
      <b-container fluid>
        <a class="anchor" id="support"></a>
        <b-row class="d-flex flex-column align-items-center my-5">
          <b-col>
            <h1 class="text-center font-weight-bold my-5">
              {{ $t('our_support') }}
            </h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h4
              class="font-weight-bold font-alt text-center"
              v-html="$t('support_text')"
            />
          </b-col>
        </b-row>
      </b-container>

      <br />
      <br />
      <br />
      <br />

      <b-container fluid>
        <b-row>
          <b-col />
          <b-col cols="10">
            <b-row>
              <b-col cols="12" lg="4">
                <b-row>
                  <b-col cols="2" />
                  <b-col cols="8">
                    <div class="d-flex flex-row justify-content-center">
                      <i
                        class="fas fa-lightbulb text-primary mt-1"
                        style="font-size: 200%"
                      />
                      <div class="d-flex flex-column pl-2">
                        <div class="d-flex">
                          <div
                            class="bg-primary mt-1"
                            style="height: 75%; width: 1.3%"
                          />
                          <h4
                            class="text-left text-primary font-alt font-weight-bold pl-2"
                            v-html="$t('ideation_offer')"
                          />
                        </div>
                        <div
                          class="font-alt text-justify"
                          v-html="$t('ideation_offer_text')"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="2" />
                </b-row>
              </b-col>

              <b-col cols="12" lg="4">
                <b-row>
                  <b-col cols="2" />
                  <b-col cols="8" class="mt-5 mt-lg-0">
                    <div class="d-flex flex-row justify-content-center">
                      <i
                        class="fas fa-database text-primary mt-1"
                        style="font-size: 200%"
                      />
                      <div class="d-flex flex-column pl-2">
                        <div class="d-flex">
                          <div
                            class="bg-primary mt-1"
                            style="height: 75%; width: 1.3%"
                          />
                          <h4
                            class="text-left text-primary font-alt font-weight-bold pl-2"
                            v-html="$t('pov_offer')"
                          />
                        </div>
                        <div
                          class="font-alt text-justify"
                          v-html="$t('pov_offer_text')"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="2" />
                </b-row>
              </b-col>

              <b-col cols="12" lg="4">
                <b-row>
                  <b-col cols="2" />
                  <b-col cols="8" class="mt-5 mt-lg-0">
                    <div class="d-flex flex-row justify-content-center">
                      <i
                        class="fas fa-cog text-primary mt-1"
                        style="font-size: 200%"
                      />
                      <div class="d-flex flex-column pl-2">
                        <div class="d-flex">
                          <div
                            class="bg-primary mt-1"
                            style="height: 75%; width: 1.3%"
                          />
                          <h4
                            class="text-left text-primary font-alt font-weight-bold pl-2"
                            v-html="$t('production_offer')"
                          />
                        </div>

                        <div
                          class="font-alt text-justify"
                          v-html="$t('production_offer_text')"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="2" />
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col />
        </b-row>
      </b-container>
    </div>
    <img src="@/assets/first_wave_bottom.svg" style="width: 100%" />

    <br />
    <br />

    <b-container fluid>
      <a class="anchor" id="engine"></a>
      <b-row class="my-5">
        <b-col>
          <h1 class="text-center font-weight-bold my-5">COsMO Engine</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h4
            class="text-center font-alt font-weight-bold"
            v-html="$t('engine_text')"
          />
        </b-col>
      </b-row>
    </b-container>

    <br />
    <br />

    <b-container fluid>
      <b-row class="my-5">
        <b-col />
        <b-col cols="10" lg="8" xl="6" align="center">
          <img
            v-if="locale === 'fr'"
            src="../assets/schema_infinity_with_words.svg"
            style="width: 100%; height: 100%"
          />
          <img
            v-else
            src="../assets/schema_infinity_with_words_english.svg"
            style="width: 100%; height: 100%"
          />
        </b-col>
        <b-col />
      </b-row>
    </b-container>

    <br />
    <br />

    <b-container fluid>
      <b-row class="my-5">
        <b-col class="d-flex flex-column align-items-center" cols="12" lg="4">
          <div
            class="d-flex flex-column align-items-center unrollable_zone"
            @click="simple_text_shown = !simple_text_shown"
          >
            <lottie-player
              id="lottie_simple_icon"
              ref="lottie_simple_icon"
              loop
              hover
              mode="normal"
              style="width: 200px"
            />
            <h2 class="text-primary font-alt font-weight-bold mb-3">
              {{ $t('simple_to_use') }}
            </h2>
            <!--             <div>
              <i
                class="text-primary fas fa-angle-down animate__animated animate__shakeY animate__infinite"
                style="font-size: 200%;"
              />
            </div> -->
            <lottie-player
              id="animated_arrow_4"
              ref="animated_arrow_4"
              autoplay
              loop
              mode="normal"
              style="width: 40px"
            />
          </div>

          <div
            class="mt-4"
            align="center"
            :class="simple_text_class"
            :style="{ visibility: simple_text_shown ? 'visible' : 'hidden' }"
            style="width: 100%; height: 100%"
          >
            <div
              class="d-block bg-white"
              style="width: 20px; height: 20px; transform: rotate(45deg)"
            />

            <b-card
              class="text-justify font-alt border-0"
              style="
                width: 75%;
                height: 100%;
                border-radius: 25px;
                margin-top: -10px;
              "
            >
              {{ $t('simple_text') }}
            </b-card>
          </div>
          <!--           <lottie-player
            v-show="simple_text_shown"
            id="lottie_simple_text"
            ref="lottie_simple_text"
            autoplay
            mode="normal"
            style="width: 75%;"
          /> -->
        </b-col>
        <b-col class="d-flex flex-column align-items-center" cols="12" lg="4">
          <div
            class="d-flex flex-column align-items-center unrollable_zone"
            @click="intelligent_text_shown = !intelligent_text_shown"
          >
            <lottie-player
              id="lottie_intelligent_icon"
              ref="lottie_intelligent_icon"
              loop
              hover
              mode="normal"
              style="width: 200px"
            />
            <h2 class="text-primary font-alt font-weight-bold mb-3">
              {{ $t('intelligent') }}
            </h2>
            <!--             <div>
              <i
                class="text-primary fas fa-angle-down animate__animated animate__shakeY animate__infinite"
                style="font-size: 200%;"
              />
            </div> -->
            <lottie-player
              id="animated_arrow_5"
              ref="animated_arrow_5"
              autoplay
              loop
              mode="normal"
              style="width: 40px"
            />
          </div>
          <div
            class="mt-4"
            align="center"
            :class="intelligent_text_class"
            :style="{
              visibility: intelligent_text_shown ? 'visible' : 'hidden',
            }"
            style="width: 100%; height: 100%"
          >
            <div
              class="d-block bg-white"
              style="width: 20px; height: 20px; transform: rotate(45deg)"
            />

            <b-card
              class="text-justify font-alt border-0"
              style="
                width: 75%;
                height: 100%;
                border-radius: 25px;
                margin-top: -10px;
              "
            >
              {{ $t('intelligent_text') }}
            </b-card>
          </div>
          <!--           <lottie-player
            v-show="intelligent_text_shown"
            id="lottie_intelligent_text"
            ref="lottie_intelligent_text"
            autoplay
            mode="normal"
            style="width: 75%;"
          /> -->
        </b-col>
        <b-col class="d-flex flex-column align-items-center" cols="12" lg="4">
          <div
            class="d-flex flex-column align-items-center unrollable_zone"
            @click="reliable_text_shown = !reliable_text_shown"
          >
            <lottie-player
              id="lottie_reliable_icon"
              ref="lottie_reliable_icon"
              loop
              hover
              mode="normal"
              style="width: 200px"
            />
            <h2 class="text-primary font-alt font-weight-bold mb-3">
              {{ $t('reliable') }}
            </h2>
            <!--             <div>
              <i
                class="text-primary fas fa-angle-down animate__animated animate__shakeY animate__infinite"
                style="font-size: 200%;"
              />
            </div> -->
            <lottie-player
              id="animated_arrow_6"
              ref="animated_arrow_6"
              autoplay
              loop
              mode="normal"
              style="width: 40px"
            />
          </div>
          <div
            class="mt-4"
            align="center"
            :class="reliable_text_class"
            :style="{ visibility: reliable_text_shown ? 'visible' : 'hidden' }"
            style="width: 100%; height: 100%"
          >
            <div
              class="d-block bg-white"
              style="width: 20px; height: 20px; transform: rotate(45deg)"
            />

            <b-card
              class="text-justify font-alt border-0"
              style="
                width: 75%;
                height: 100%;
                border-radius: 25px;
                margin-top: -10px;
              "
            >
              {{ $t('reliable_text') }}
            </b-card>
          </div>

          <!--           <lottie-player
            v-show="reliable_text_shown"
            id="lottie_reliable_text"
            ref="lottie_reliable_text"
            autoplay
            mode="normal"
            style="width: 75%;"
          /> -->
        </b-col>
      </b-row>
    </b-container>

    <br />
    <br />

    <img src="@/assets/second_wave_top.svg" style="width: 100%" />

    <div class="bg-white">
      <br />
      <br />
      <b-container fluid>
        <a class="anchor" id="ecosystem"></a>
        <b-row class="d-flex flex-column align-items-center my-5">
          <b-col>
            <h1 class="text-center font-weight-bold my-5">
              {{ $t('excellent_ecosystem') }}
            </h1>
          </b-col>

          <br />
          <br />

          <h4
            class="font-alt font-weight-bold font-alt text-center"
            v-html="$t('ecosystem_text')"
          />
        </b-row>
      </b-container>

      <br />

      <b-container fluid>
        <b-row class="justify-content-center mt-5">
          <b-col />
          <b-col cols="10" lg="8" xl="6">
            <img src="@/assets/logosv2.svg" style="width: 100%; height: 100%" />
          </b-col>
          <b-col />
        </b-row>
      </b-container>
      <br />
      <br />
    </div>

    <img src="@/assets/second_wave_bottom.svg" style="width: 100%" />

    <br />
    <br />
    <br />
    <br />

    <b-container fluid>
      <a class="anchor" id="board"></a>
      <b-row class="my-5">
        <b-col>
          <h1 class="font-weight-bold text-center my-5">
            {{ $t('synaplus_board') }}
          </h1>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid>
      <b-row class="justify-content-center my-5">
        <b-col />
        <b-col cols="10">
          <b-row>
            <b-col cols="12" lg="6">
              <div class="d-flex flex-column align-items-center">
                <img
                  class="mb-2"
                  src="../assets/michel_bastide_rounded_gray.jpg"
                />

                <h4 class="font-alt font-weight-bold mt-4">Michel Bastide</h4>
                <div class="text-primary font-alt font-weight-bold">CEO</div>
              </div>
            </b-col>

            <b-col class="mt-5 mt-lg-0" cols="12" lg="6">
              <div class="d-flex flex-column align-items-center">
                <img
                  class="mb-2"
                  src="../assets/charles_antoine_giuliani_rounded_gray.jpg"
                />

                <h4 class="font-alt font-weight-bold mt-4">
                  Charles-Antoine Giuliani
                </h4>
                <div class="text-primary font-alt font-weight-bold">
                  {{ $t('president') }} & CTO
                </div>
              </div>
            </b-col>

            <!--             <b-col class="mt-5 mt-lg-0" cols="12" lg="4">
              <div class="d-flex flex-column align-items-center">
                <img
                  class="mb-2"
                  src="../assets/lionel_dauriac_rounded_gray.jpg"
                />
                <h4 class="font-alt font-weight-bold mt-4">
                  Lionel D'Auriac
                </h4>
                <div class="text-primary font-alt font-weight-bold">
                  CFO
                </div>
              </div>
            </b-col>
 -->
          </b-row>
        </b-col>
        <b-col />
      </b-row>
    </b-container>

    <br />
    <br />

    <b-container fluid>
      <a class="anchor" id="board"></a>
      <b-row class="my-5">
        <b-col>
          <h1 class="font-weight-bold text-center my-5">
            {{ $t('scientific_council') }}
          </h1>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid>
      <b-row class="justify-content-center my-5">
        <b-col />
        <b-col cols="10">
          <b-row>
            <b-col cols="12" lg="4">
              <div class="d-flex flex-column align-items-center">
                <img
                  class="mb-2"
                  src="../assets/cedric_villani_rounded_gray.jpg"
                />

                <h4 class="font-alt font-weight-bold mt-4">Cédric Villani</h4>
                <div class="text-primary font-alt font-weight-bold">
                  {{ $t('fields_medal') }}
                </div>
              </div>
            </b-col>

            <b-col class="mt-5 mt-lg-0" cols="12" lg="4">
              <div class="d-flex flex-column align-items-center">
                <img
                  class="mb-2"
                  src="../assets/marc_schoenauer_rounded_gray.jpg"
                />

                <h4 class="font-alt font-weight-bold mt-4">Marc Schoenauer</h4>
                <div
                  class="text-primary font-alt font-weight-bold"
                  align="center"
                >
                  {{ $t('research_director') }}
                  <br />
                  INRIA
                </div>
              </div>
            </b-col>

            <b-col class="mt-5 mt-lg-0" cols="12" lg="4">
              <div class="d-flex flex-column align-items-center">
                <img
                  class="mb-2"
                  src="../assets/victor_storchan_rounded_gray.jpg"
                />
                <h4 class="font-alt font-weight-bold mt-4">Victor Storchan</h4>
                <div
                  class="text-primary font-alt font-weight-bold"
                  align="center"
                >
                  AI ML Lead
                  <br />
                  JP Morgan
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col />
      </b-row>
    </b-container>

    <br />

    <b-container fluid>
      <b-row class="justify-content-center mt-5">
        <b-btn
          v-b-modal.modal_contact_form
          variant="primary"
          class="mx-3 px-3 font-alt font-weight-bold"
          pill
        >
          {{ $t('free_demo') }}
        </b-btn>
        <b-btn
          v-b-modal.modal_contact_form
          variant="outline-primary"
          class="mx-3 px-3 font-alt font-weight-bold"
          pill
        >
          {{ $t('contact_us') }}
        </b-btn>
      </b-row>
    </b-container>
  </div>
</template>

<i18n>
{
  "en": {
    "seven_weeks": "Deliver your AI projects <br /> in 7 weeks",
    "free_demo": "Free demo",
    "contact_us": "Contact us",
    "now_everywhere_everyone": "Now, everywhere, for everyone",
    "now": "Now",
    "now_text": "Start your projects right now from a simple idea and have concrete results within 7 weeks",
    "everywhere": "Everywhere",
    "everywhere_text": "Whichever your line of business, all your business tasks can be optimized : predict, detect, recommend, prioritize, personnalize",
    "for_everyone": "For everyone",
    "everyone_text": "Big companies, Mid-Caps, SMEs, control your costs at challenging market prices",
    "our_support": "Our support",
    "support_text": "<span class='text-primary'>Synaplus</span> accompanies you during the implementation <br /> of your first AI projects with <span class='text-primary'>COsMO Engine</span>",
    "ideation_offer": "Ideation <br /> Offer",
    "ideation_offer_text": "<span class='font-weight-bold'>Identify</span> together your business cases through a creative and collaborative workshop",
    "pov_offer": "Proof of value <br /> Offer",
    "pov_offer_text": "<span class='font-weight-bold'>Build</span> together in 7 weeks an AI solution meeting all your needs thanks to an agile approach based on COsMO Engine",
    "production_offer": "Production <br /> Offer",
    "production_offer_text": "<span class='font-weight-bold'>Deploy</span> together the solution in your Information System and manage its production lifecycle",
    "engine_text": "<span class='text-primary'>COsMO Engine</span> is the <span class='text-primary'>AI engine</span> supporting all <br /> your Data Science project operations",
    "simple_to_use": "Simple to use",
    "simple_text": "All your data experts can implement projects without the need to code",
    "intelligent": "Intelligent",
    "intelligent_text": "All operations and computations are realized by an AI so that you can focus on business needs and which data to use",
    "reliable": "Reliable",
    "reliable_text": "Validate each step of the project lifecycle thanks to relevant explainabilities and justifications during proof of value, deployment, run, retrain, upgrades",
    "excellent_ecosystem": "An ecosystem of excellency",
    "ecosystem_text": "Member of a European <br /> ecosystem of <span class='text-primary'>Deep Tech</span>",
    "synaplus_board": "An experienced team",
    "scientific_council": "A world renowned scientific council",
    "president": "President, founder",
    "fields_medal": "Fields medal",
    "research_director": "Research Director"
  },
  "fr": {
    "seven_weeks": "Réalisez vos projets d'IA <br /> en 7 semaines",
    "free_demo": "Démo gratuite",
    "contact_us": "Nous contacter",
    "now_everywhere_everyone": "Maintenant, partout, pour tout le monde",
    "now": "Maintenant",
    "now_text": "Démarrez vos projets immédiatement, à partir d’une simple idée et obtenez des résultats utilisables sous 7 semaines",
    "everywhere": "Partout",
    "everywhere_text": "Quel que soit votre secteur d’activité, tous vos gestes métiers peuvent être optimisés : prédire, détecter, recommander, prioriser, personnaliser",
    "for_everyone": "Pour tout le monde",
    "everyone_text": "Grande entreprise, ETI, PME, engagez vous sur des coûts maitrisés et défiant les prix du marché",
    "our_support": "Notre accompagnement",
    "support_text": "<span class='text-primary'>Synaplus</span> vous accompagne dans la mise en oeuvre <br /> de vos premiers projets d'IA avec <span class='text-primary'>COsMO Engine</span>",
    "ideation_offer": "Offre <br /> Idéation",
    "ideation_offer_text": "<span class='font-weight-bold'>Identifions </span> ensemble vos cas d’usages au travers d’un atelier créatif et coopératif",
    "pov_offer": "Offre <br /> Preuve de valeur",
    "pov_offer_text": "<span class='font-weight-bold'>Construisons </span> ensemble en 7 semaines une solution d'IA répondant à votre besoin grâce à une approche agile basée sur COsMO Engine",
    "production_offer": "Offre <br /> Production",
    "production_offer_text": "<span class='font-weight-bold'>Déployons </span> ensemble la solution dans votre Système d'Information et gérons son cycle de vie en production",
    "engine_text": "<span class='text-primary'>COsMO Engine</span> est le <span class='text-primary'>moteur d’IA</span> prenant en charge toutes les <br /> opérations de votre projet datascience",
    "simple_to_use": "Simple à utiliser",
    "simple_text": "Les projets sont réalisables par tous vos experts data, sans besoin de coder à travers une interface intuitive",
    "intelligent": "Intelligent",
    "intelligent_text": "Toutes les opérations et calculs sont réalisés par une IA qui vous permet de vous concentrer sur le besoin métier et les données à utiliser",
    "reliable": "Fiable",
    "reliable_text": "Des explicabilités et justifications pertinentes vous permettent de valider chaque étape du cycle de vie du projet : proof of value, deployment, run, retrain, changes",
    "excellent_ecosystem": "Un écosystème d'excellence",
    "ecosystem_text": "Membre d'un écosystème <br /> européen de <span class='text-primary'>Deep Tech</span>",
    "synaplus_board": "Une équipe expérimentée",
    "scientific_council": "Un conseil scientifique de renommée mondiale",
    "president": "Président fondateur",
    "fields_medal": "Médaillé Fields",
    "research_director": "Directeur de recherches"
  }
}
</i18n>

<style>
/*.dashed-lines {
  background-image: repeating-linear-gradient(
    90deg,
    transparent 0% transparent 16%,
    black 16% black 17%
  );
  background-size: 100% 100%;
}*/

.background_image_hands {
  background-image: url('../assets/background_image_hands.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center bottom 150px;
  width: 100%;
}

.clickable_thumbnail {
  cursor: pointer;
  width: 100%;
}

.unrollable_zone {
  cursor: pointer;
}

:root {
  --animate-duration: 6s;
}

.scale-up-ver-top {
  -webkit-animation: scale-up-ver-top 0.4s cubic-bezier(0.39, 0.575, 0.565, 1)
    both;
  animation: scale-up-ver-top 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

@-webkit-keyframes scale-up-ver-top {
  0% {
    -webkit-transform: scaleY(0.4);
    transform: scaleY(0.4);
    -webkit-transform-origin: 100% 0%;
    transform-origin: 100% 0%;
  }
  100% {
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: 100% 0%;
    transform-origin: 100% 0%;
  }
}
@keyframes scale-up-ver-top {
  0% {
    -webkit-transform: scaleY(0.4);
    transform: scaleY(0.4);
    -webkit-transform-origin: 100% 0%;
    transform-origin: 100% 0%;
  }
  100% {
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: 100% 0%;
    transform-origin: 100% 0%;
  }
}

.slide-bottom {
  -webkit-animation: slide-bottom 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    infinite both;
  animation: slide-bottom 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) infinite
    both;
}

@-webkit-keyframes slide-bottom {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(20px);
    transform: translateY(20px);
  }
}
@keyframes slide-bottom {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(20px);
    transform: translateY(20px);
  }
}
</style>

<style lang="scss" scoped>
a.anchor {
  display: block;
  position: relative;
  top: -86px;
  visibility: hidden;
}
</style>

<script>
import _ from 'lodash'
import 'animate.css'
// import lottie from 'lottie-web'
import * as LottiePlayer from '@lottiefiles/lottie-player'
import { mapState } from 'vuex'

import ContactForm from '@/components/contact_form.vue'

// const icon_pulse_now = () => import('@/assets/icon_pulse_now.json')
// const icon_pulse_everywhere = () =>
//   import('@/assets/icon_pulse_everywhere.json')
// const icon_pulse_everyone = () => import('@/assets/icon_pulse_everyone.json')

// const icon_pulse_simple = () => import('@/assets/icon_pulse_simple.json')
// const icon_pulse_intelligent = () =>
//   import('@/assets/icon_pulse_intelligent.json')
// const icon_pulse_reliable = () => import('@/assets/icon_pulse_reliable.json')

const icon_pulse_now = () => import('@/assets/icon_pulse_now_bigger.json')
const icon_pulse_everywhere = () =>
  import('@/assets/icon_pulse_everywhere_bigger.json')
const icon_pulse_everyone = () =>
  import('@/assets/icon_pulse_everyone_bigger.json')

const icon_pulse_simple = () => import('@/assets/icon_pulse_simple_bigger.json')
const icon_pulse_intelligent = () =>
  import('@/assets/icon_pulse_intelligent_bigger.json')
const icon_pulse_reliable = () =>
  import('@/assets/icon_pulse_reliable_bigger.json')

const animated_arrow = () => import('@/assets/animated_arrow.json')

export default {
  name: 'MainPage',
  components: {
    ContactForm,
    // LottieVuePlayer,
    // LottiePlayer,
  },

  data() {
    return {
      video_src: '',
      now_text_shown: false,
      everywhere_text_shown: false,
      everyone_text_shown: false,
      simple_text_shown: false,
      intelligent_text_shown: false,
      reliable_text_shown: false,
    }
  },

  mounted() {
    let self = this

    icon_pulse_now().then(function (data) {
      self.$refs.lottie_now_icon.load(data)
    })
    icon_pulse_everywhere().then(function (data) {
      self.$refs.lottie_everywhere_icon.load(data)
    })
    icon_pulse_everyone().then(function (data) {
      self.$refs.lottie_everyone_icon.load(data)
    })

    icon_pulse_simple().then(function (data) {
      self.$refs.lottie_simple_icon.load(data)
    })
    icon_pulse_intelligent().then(function (data) {
      self.$refs.lottie_intelligent_icon.load(data)
    })
    icon_pulse_reliable().then(function (data) {
      self.$refs.lottie_reliable_icon.load(data)
    })

    // animated_arrow().then(function(data) {
    //   self.$refs.animated_arrow.load(data)
    // })

    animated_arrow().then(function (data) {
      _.forEach(_.range(1, 7), arrow_index => {
        self.$refs['animated_arrow_' + arrow_index].load(data)
      })
    })
  },

  computed: {
    now_text_class() {
      let res = []
      if (this.now_text_shown) {
        res.push('scale-up-ver-top')
      }
      return res
    },
    everywhere_text_class() {
      let res = []
      if (this.everywhere_text_shown) {
        res.push('scale-up-ver-top')
      }
      return res
    },
    everyone_text_class() {
      let res = []
      if (this.everyone_text_shown) {
        res.push('scale-up-ver-top')
      }
      return res
    },
    simple_text_class() {
      let res = []
      if (this.simple_text_shown) {
        res.push('scale-up-ver-top')
      }
      return res
    },
    intelligent_text_class() {
      let res = []
      if (this.intelligent_text_shown) {
        res.push('scale-up-ver-top')
      }
      return res
    },
    reliable_text_class() {
      let res = []
      if (this.reliable_text_shown) {
        res.push('scale-up-ver-top')
      }
      return res
    },
    ...mapState(['locale']),
  },

  methods: {
    start_video() {
      this.$refs.videomodal.show()
    },
    on_videomodal_shown() {
      this.video_src =
        'https://www.youtube.com/embed/nnmjofiN5To' +
        '?rel=0&amp;autoplay=1&amp;modestbranding=1'
    },
    on_videomodal_hidden() {
      this.video_src = ''
    },
  },
}
</script>
